import {createAction, props} from '@ngrx/store';
import {SearchPayload, SearchResultsPayload} from './entities/payloads';

export const fetchSearchResults = createAction('[KP_Search] Fetch Search Results', props<SearchPayload>());
export const updateSearchResults = createAction('[KP_Search] Update Search Results', props<SearchResultsPayload>());
export const start = createAction('[KP_Search] Start', props<{}>());
export const done = createAction('[KP_Search] Done', props<{}>());

